var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 0H4.8525C4.0275 0 3.3525 0.675 3.3525 1.5V4.2225H2.25C1.425 4.2225 0.75 4.8975 0.75 5.7225V14.01C0.75 14.835 1.425 15.51 2.25 15.51H13.1475C13.9725 15.51 14.6475 14.835 14.6475 14.01V11.2875H15.75C16.575 11.2875 17.25 10.6125 17.25 9.7875V1.5C17.25 0.675 16.575 0 15.75 0ZM13.1475 14.01H2.25V5.7225H13.1475V14.01ZM15.75 9.7875H14.6475V5.7225C14.6475 4.8975 13.9725 4.2225 13.1475 4.2225H4.8525V1.5H15.75V9.7875Z",
    fill: "#35373A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotice);
export default __webpack_public_path__ + "static/media/icon_notice.3ba2965eec7cfe9f37ca7143d233cbcf.svg";
export { ForwardRef as ReactComponent };